'use client'

import getLocale from '@/stores/locales'
import { Col, Row } from 'antd'
import Title from './Title'

const HeaderRow = (props: { searchTerm: string; itemsFound: number }) => {
  const copy = getLocale()

  return (
    <Row style={{ marginBottom: 16 }}>
      <Col flex="auto">
        <Title
          resultsFor={copy?.filter?.resultsFor}
          searchTerm={props.searchTerm}
          itemsFound={props.itemsFound}
        />
      </Col>
    </Row>
  )
}

export default HeaderRow
